import { z } from 'zod';

export const englishIqProgressV2Schema = z.object({
  answered: z.number().int().nonnegative(),
  total: z.number().int().positive(),
});

export type IEnglishIqProgressV2 = z.infer<typeof englishIqProgressV2Schema>;
